/* @flow */

import {
  SET_TAGS,
  ADD_TAG,
  UPDATE_TAG,
  DELETE_TAG,
  SHOW_TAG_PICKER,
  HIDE_TAG_PICKER,
  FORCE_TAG_PICKER_OPEN,
  SET_TAG_SORT_INFO
} from './types';

import type { Action } from 'redux';

type State = {
  tags: Array<Object>,
  isTagPickerOpen: boolean,
  activeCustomerId: ?string,
  sortInfo: ?Object
};

const initialState: State = {
  tags: [],
  isTagPickerOpen: false,
  activeCustomerId: null,
  sortInfo: { Name: 1 } // Default sorting by name in ascending order
};

const tagsReducer = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case SET_TAGS:
      return {
        ...state,
        tags: action.payload || []
      };
      
    case ADD_TAG:
      // Add or update a tag in the tags array
      const tagExists = state.tags.some(tag => tag._id === action.payload.tag._id);
      
      if (tagExists) {
        // If tag exists, update it
        return {
          ...state,
          tags: state.tags.map(tag => 
            tag._id === action.payload.tag._id ? action.payload.tag : tag
          )
        };
      } else {
        // If tag doesn't exist, add it
        return {
          ...state,
          tags: [...state.tags, action.payload.tag]
        };
      }
      
    case UPDATE_TAG:
      // Update an existing tag
      console.log('[tagsReducer] UPDATE_TAG action received:', action.payload);
      console.log('[tagsReducer] Current tags before update:', state.tags);
      const updatedState = {
        ...state,
        tags: state.tags.map(tag => {
          if (tag._id === action.payload._id) {
            console.log('[tagsReducer] Updating tag from:', tag, 'to:', { ...tag, ...action.payload });
            return { ...tag, ...action.payload };
          }
          return tag;
        })
      };
      console.log('[tagsReducer] Tags after update:', updatedState.tags);
      return updatedState;
      
    case DELETE_TAG:
      // Remove a tag from the tags array
      return {
        ...state,
        tags: state.tags.filter(tag => tag._id !== action.payload.tag._id)
      };
      
    case SHOW_TAG_PICKER:
      return {
        ...state,
        isTagPickerOpen: true,
        activeCustomerId: action.payload.customerId
      };
      
    case HIDE_TAG_PICKER:
      return {
        ...state,
        isTagPickerOpen: false,
        activeCustomerId: null
      };
      
    case FORCE_TAG_PICKER_OPEN:
      return {
        ...state,
        isTagPickerOpen: action.payload.open,
        activeCustomerId: action.payload.customerId
      };
      
    case SET_TAG_SORT_INFO:
      return {
        ...state,
        sortInfo: action.payload
      };
      
    default:
      return state;
  }
};

export default tagsReducer;